import React, { useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';
import ViewDeliveryReportModal from '../../custom-components/delivery-reports/ViewDeliveryReportModal';

const ViewDeliveryReportDialog = ({ data, title, onOpenChange }) => {
    const [open, setOpen] = useState(false);
    // PFM-3150: report nested v5 modal open state to an owning v4 dialog.
    const openRef = useRef(false);
    const onOpenChangeRef = useRef(onOpenChange);
    onOpenChangeRef.current = onOpenChange;

    const handleOpenChange = (isOpen) => {
        openRef.current = isOpen;
        setOpen(isOpen);
        onOpenChange?.(isOpen);
    };

    useEffect(
        () => () => {
            if (openRef.current) onOpenChangeRef.current?.(false);
        },
        []
    );

    return (
        <>
            <Button disabled={!data?.delivery_report} variant="contained" color="primary" className="my-16" aria-label={title} onClick={() => handleOpenChange(true)}>
                {title}
            </Button>

            <ViewDeliveryReportModal open={open} handleClose={() => handleOpenChange(false)} fileName={data?.delivery_report} />
        </>
    );
};

export default ViewDeliveryReportDialog;
